export const AUTH_ADMIN_REQUEST = 'auth/admin-request'
export const AUTH_ADMIN_SUCCESS = 'auth/admin-success'
export const AUTH_ADMIN_FAILED = 'auth/admin-failed'
